/**
 * @generated SignedSource<<82567e4f7838299c5f802d9aafe4b70a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ReturnAssetInput = {
  assetTag: any;
  clientMutationId?: string | null | undefined;
  reservationId: string;
};
export type OpsReservationPageReturnMutation$variables = {
  input: ReturnAssetInput;
};
export type OpsReservationPageReturnMutation$data = {
  readonly returnAsset: {
    readonly reservation: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly assetTag: any | null | undefined;
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsReservationPageReturnMutation = {
  response: OpsReservationPageReturnMutation$data;
  variables: OpsReservationPageReturnMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ReturnAssetPayload",
    "kind": "LinkedField",
    "name": "returnAsset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Reservation",
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsReservationPageReturnMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsReservationPageReturnMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "385e892196c16a047d642d328ab908a2",
    "id": null,
    "metadata": {},
    "name": "OpsReservationPageReturnMutation",
    "operationKind": "mutation",
    "text": "mutation OpsReservationPageReturnMutation(\n  $input: ReturnAssetInput!\n) {\n  returnAsset(input: $input) {\n    reservation {\n      id\n    }\n    userErrors {\n      message\n      assetTag\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ae87a22de3a72aca4b060c969c6cbf3e";

export default node;
